import { useRoutes } from "react-router-dom";
import { getStoredToken } from "../services/user-storage";
import HomePage from "../pages/Home";
import NotFoundPage from "../pages/NotFound";
import ContactPage from "../pages/Contact";
import ProtectedRoute from "../components/ProtectedRoute";
import CategoriesPage from "../pages/Category";
import Main from "../components/Layout/Main";
import routesProduct from "./routesProduct";
import routesPopularProduct from "./routesPopularProduct";
import routesOffer from "./routesOffer";
import routesOrders from "./routesOrders";
import routesCart from "./routesCart";
import routesFavorite from "./routesFavorite";
import routesSettings from "./routesSettings";
import routesAuthentication from "./routesAuthentication";

function RoutesWrapper() {
  const isAuthenticated = getStoredToken() !== null;
  
  const routes = useRoutes([
    {
      path: "*",
      element: <NotFoundPage />,
    },
    {
      path: "/",
      element: <Main />,
      children: [
        {
          path: "/",
          element: <HomePage />,
        },
        {
          path: "/contact",
          element: <ContactPage />,
        },
        {
          path: "/categories",
          element: <CategoriesPage />,
        },
        ...routesAuthentication,
        ...routesProduct,
        ...routesOffer,
        ...routesPopularProduct,

        // Protected routes (Only accessible if authenticated)
        {
          element: <ProtectedRoute isAuthenticated={isAuthenticated} />,
          children: [
            ...routesOrders,
            ...routesCart,
            ...routesFavorite,
            ...routesSettings
          ],
        },
      ],
    },
  ]);

  return routes;
}

export default RoutesWrapper;
